import { useNavigationBlocker } from '@shared/hooks/useNavigationBlocker';
import IContentDialogProps from '@shared/models/components/IContentDialogProps';
import { useTranslation } from 'react-i18next';
import ContentDialog from '../core/dialog/ContentDialog';

export interface IUnsavedChangesDialogProps extends Omit<
    IContentDialogProps,
    'open' | 'title' | 'onClose' | 'onCancel' | 'onConfirm'
> {
    hasChanges: boolean;
    setHasChanges: (hasChanges: boolean) => void;
    onSave: () => void | Promise<void>;
    title?: string;
}

export default function UnsavedChangesDialog({
    hasChanges,
    setHasChanges,
    onSave,
    title,
    description,
    confirmButtonText,
    cancelButtonText,
    ...restProps
}: IUnsavedChangesDialogProps) {
    const { t } = useTranslation();
    const { openDialog, handleConfirm, handleCancel, handleContinue } = useNavigationBlocker({
        shouldBlock: hasChanges,
        onConfirm: onSave,
    });

    const handleContinueWithState = async () => {
        await handleContinue();
        setHasChanges(false);
    };

    return (
        <ContentDialog
            open={openDialog}
            title={title ?? t('common:unsaved.title')}
            description={description ?? t('common:unsaved.description')}
            confirmButtonText={confirmButtonText ?? t('common:unsaved.confirm')}
            cancelButtonText={cancelButtonText ?? t('common:unsaved.cancel')}
            onConfirm={handleConfirm}
            onCancel={handleContinueWithState}
            onClose={handleCancel}
            {...restProps}
        />
    );
}
